import {
  ChoiceSectionDefinition,
  InfoSection,
  InfoSectionDefinition,
  TextSectionDefinition
} from "@/pb/api/devplan/types/common";

export const DemoSections: Record<string, string> = {
  "description": "We're building a mobile app that helps users track their workouts, nutrition, and recovery with " +
    "personalized recommendations. The product includes activity logging, wearable device sync, progress insights, " +
    "and habit coaching. Our users range from casual fitness enthusiasts to personal trainers who want a more " +
    "data-driven way to stay on track and hit their goals.",
  "keyFeatures": "Workout tracking, nutrition logging, wearable device sync, personalized fitness plans",
  "competitors": "MyFitnessPal, Strava, WHOOP",
  "companyGoals": "Launch beta, reach 1,000 active users, increase daily engagement",
}

export function hasTextSection(sections: InfoSection[], name: string): boolean {
  const v = sections.find(s => s.name === name)
  return v !== undefined && v.type?.$case === "text" && v.type.value.text.length > 0
}

export function updateTextSection(sections: InfoSection[], name: string, text: string) {
  return getUpdatesSections(sections, {name, type: {$case: "text", value: {text}}})
}

export function getUpdatesSections(sections: InfoSection[], updated: InfoSection): InfoSection[] {
  const result = [...sections]
  const idx = result.findIndex(s => s.name === updated.name)
  if (idx >= 0) {
    result[idx] = updated
  } else {
    result.push(updated)
  }
  return result
}

export const availableCompanyInfoSections: InfoSectionDefinition[] = [
  InfoSectionDefinition.create({
    name: "description",
    title: "What do you do?",
    description: "Give us a short description of your company, product and users.",
    type: {$case: "text", value: TextSectionDefinition.create({})}
  }),
  // InfoSectionDefinition.create({
  //   name: "area",
  //   title: "Industry Tags",
  //   description: "Pick the categories that best fit your product.",
  //   type: {
  //     $case: "choice", value: ChoiceSectionDefinition.create({
  //       multi: true, choices: [
  //         "SaaS", "Marketplace", "E-Commerce", "Fintech", "Healthtech",
  //         "Edtech", "Consumer App", "Enterprise Software", "Hardware / IoT",
  //         "AI / ML Platform",
  //       ]
  //     })
  //   }
  // }),
  // InfoSectionDefinition.create({
  //   name: "companyType",
  //   title: "Company Type",
  //   description: "What stage are you in?",
  //   type: {
  //     $case: "choice", value: ChoiceSectionDefinition.create({
  //       multi: false, choices: [
  //         "Pre-seed Startup", "Early-stage (Seed or A)", "Growth-stage (series B+)",
  //         "Public Company", "Bootstrapped", "Solopreneur / Side Project", "Agency or Consultancy",
  //         "University or Nonprofit"
  //       ]
  //     })
  //   }
  // }),
  InfoSectionDefinition.create({
    name: "size",
    title: "Team Size",
    description: "Used to tailor your AI planning experience.",
    type: {
      $case: "choice", value: ChoiceSectionDefinition.create({
        choices: ["1-5", "6-10", "11-100", "101-500", "501-2000", "2001+"]
      })
    }
  }),
  InfoSectionDefinition.create({
    name: "targetPersona",
    title: "Who are your target customers?",
    description: "Who uses this product? Job titles are ideal.",
    type: {$case: "text", value: TextSectionDefinition.create({})}
  }),
  InfoSectionDefinition.create({
    name: "productType",
    title: "What types of products do you offer?",
    description: "If you offer a one product, tell us what it is does, or if you offer multiple products, describe them for us.",
    type: {$case: "text", value: TextSectionDefinition.create({})}
  }),
  InfoSectionDefinition.create({
    name: "keyFeatures",
    title: "What does your product do today?",
    description: "List key current features or workflows. If it's new, write \"new product.\"",
    type: {$case: "text", value: TextSectionDefinition.create({})}
  }),
  InfoSectionDefinition.create({
    name: "competitors",
    title: "Who do you compete with (if anyone)?",
    description: "This helps us avoid generic suggestions and get more specific.",
    type: {$case: "text", value: TextSectionDefinition.create({})}
  }),
  InfoSectionDefinition.create({
    name: "companyGoals",
    title: "What are your top goals?",
    description: "Tell us what success looks like — product milestones, usage targets, or launches.",
    type: {$case: "text", value: TextSectionDefinition.create({})}
  }),
]

export const availableUserInfoSections: InfoSectionDefinition[] = [
  InfoSectionDefinition.create({
    name: "role",
    title: "Choose which best describe your role",
    type: {
      $case: "choice", value: ChoiceSectionDefinition.create({
        multi: true,
        choices: ["Founder", "Solopreneur", "Product", "Engineering", "Design", "Marketing", "Operations", "Other"]
      })
    }
  }),
  InfoSectionDefinition.create({
    name: "why_using",
    title: "Choose which ways you plan to use Devplan",
    type: {
      $case: "choice", value: ChoiceSectionDefinition.create({
        multi: true,
        choices: ["Define requirements", "Specs to stories", "Create tickets", "Plan development", "Build MVP",
          "AI Coding", "Other"]
      })
    }
  }),
]
